<template>
  <div id="entire_app__dashboard">
    <div
      :class="{
        '--booking_in_progress': $store.state.Booking.bookingInProgress,
      }"
      class="ticket_booking_order"
    ></div>

    <div
      v-if="$store.state.SidebarToggle.loadingPageData"
      :class="{
        '--booking_in_progress': $store.state.SidebarToggle.loadingPageData,
      }"
      class="ticket_booking_order"
    >
      <div class="ticking_procedure_background loading_data_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container loading_container col-mob-11">
          <img class="logo col-mob-5" src="../../assets/logo.png" alt="" />
          <img class="loader" src="../../assets/loading.gif" alt="" />
        </div>
      </div>
    </div>

    <div class="entire_app__dashboard">
      <div
        class="entire_app__sidebar_container"
        :class="{
          '--sidebar_toggled': $store.state.SidebarToggle.sidebar_toggled,
        }"
      >
        <ShaloiSidebar />
      </div>
      <div
        class="entire_app_mobile_sidebar_container"
        v-if="$store.state.Customizations.mobile_siderbar_toggled"
      >
        <shaloi-mobile-sidebar />
      </div>

      <div class="__mobile_navigation">
        <div class="logo_container">
          <div class="menu_toggle">
            <svg
              id="menu"
              @click="$store.commit('Customizations/togglemobilesidebar')"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 28"
            >
              <path
                id="Path_1"
                data-name="Path 1"
                d="M0,0H28V28H0Z"
                fill="none"
              />
              <path
                id="Path_2"
                data-name="Path 2"
                d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z"
                transform="translate(0)"
                fill="#1d2329"
              />
            </svg>
          </div>
          <div class="logo">
            <img src="../../assets/logo.png" alt="logo" />
          </div>
          <div class="settings">
            <router-link to="/shaloi/profile"
              ><svg
                @click="
                  $store.commit('Customizations/togglemobilesidebartofalse')
                "
                id="settings"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_3"
                  data-name="Path 3"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  id="Path_4"
                  data-name="Path 4"
                  d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z"
                  transform="translate(0 0)"
                  fill="#1d2329"
                /></svg
            ></router-link>
          </div>
        </div>
      </div>
      <div
        class="entire_app__page_content"
        :class="{
          '--sidebar_toggled_expd_body':
            $store.state.SidebarToggle.sidebar_toggled,
        }"
      >
        <div class="content_container">
          <div class="title_container">
            <svg
              id="pulse-fill"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
            >
              <path
                id="Path_31"
                data-name="Path 31"
                d="M0,0H24V24H0Z"
                fill="none"
              />
              <path
                id="Path_32"
                data-name="Path 32"
                d="M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z"
                fill="#1d2329"
              />
            </svg>
            <h2>Today's Performance</h2>
          </div>

          <DayPerformanceOverview class="branch-overview" />
          <setRoutesComponent />
        </div>
        <!-- <div class="notifications_container">
          <notification-side />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ShaloiSidebar from "@/components/ShaloiSidebar.vue";
import NotificationSide from "../../components/NotificationSide.vue";
import ShaloiMobileSidebar from "@/components/ShaloiMobileSidebar.vue";
import setRoutesComponent from "./components/setRoutes.vue";
import DayPerformanceOverview from "./components/overview";
import jwt_decode from "jwt-decode";
import axios from "axios";
import router from "../../router/index";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  components: {
    ShaloiSidebar,
    NotificationSide,
    setRoutesComponent,
    DayPerformanceOverview,
    ShaloiMobileSidebar,
  },

  data() {
    return {
      ticketId: "",
    };
  },
  created() {
    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if (userRole != "shaloi") return router.push("/dashboard");
    this.getShaloiStatus();
    $(document).ready(function() {
      $(".show-modal").click(function() {
        $("#myModal").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
  },
  methods: {
    getShaloiStatus() {
      axios
        .get(
          "https://bookinga.herokuapp.com/api/v1/company/shaloi/hasbranch",
          config
        )
        .then((result) => {
          if (result.data.data[0].hasbranch == false) {
            return router.push("/shaloi/NoBranch");
          }
        })
        .catch((err) => {});
    },
  },
  updated() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let ticketId = params.get("ticket");

    this.ticketId = ticketId;
  },
};
</script>

<style lang="scss" scoped>
.title_container {
  width: 100%;
  height: fit-content;
  margin-bottom: 10px;
  display: flex;
  position: relative;
  margin-top: 1em;

  h2 {
    font-size: 1em;
    font-family: satoshi, $poppins !important;
    position: relative;
    font-weight: 600;
    left: 2%;
  }

  svg {
    position: relative;
    left: 1%;
  }
}
.set-routes-container {
  width: 97.8%;
  margin: 0 auto;
}
.content_container {
  overflow-y: scroll;
  // -ms-overflow-style: none; /* IE and Edge */
  // scrollbar-width: none; /* Firefox */
}
.content_container::-webkit-scrollbar {
  width: 5px;
  background-color: rgb(255, 255, 255);
}
.content_container::-webkit-scrollbar-thumb {
  background: rgb(172, 203, 243);
}

#entire_app__dashboard {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;

  .--booking_in_progress {
    display: block !important;
  }

  .ticket_booking_order {
    position: absolute;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999;
    display: none;
    transition: all 0.5s ease;

    .ticking_procedure_background {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: $dimestDark;
      opacity: 0.55;
    }

    .loading_data_background {
      background-color: $pureWhite !important;
      opacity: 1 !important;
    }

    .error_occurred_container {
      width: 100%;
      height: 100vh;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;

      .loading_container {
        flex-direction: column;
        .logo {
          width: 30%;
        }

        .loader {
          width: 10%;
          margin-top: 2em;
        }
      }

      .alert_container {
        position: fixed;
        background-color: $pureWhite;
        width: 40%;
        height: auto;
        min-height: 28% !important;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.5s ease !important;
        padding: 0.2em;

        .error_image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30%;
          height: 100%;

          img {
            width: 85%;
            height: auto;
          }
        }
      }
    }

    .ticket_booking_procedure_container {
      width: 100%;
      height: 100%;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;

      .procedure_form {
        position: fixed;
        background-color: $pureWhite;
        width: 35%;
        height: auto;
        min-height: 80%;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.5s ease !important;
      }
    }
  }
}

.entire_app__dashboard {
  width: 100%;
  height: 100%;
  display: flex;

  .entire_app_mobile_sidebar_container {
    display: none;
  }

  .__mobile_navigation {
    display: none;
  }

  .--sidebar_toggled {
    width: 6.5% !important;
    height: 100% !important;
  }

  .--sidebar_toggled_expd_body {
    width: 93.5% !important;
  }

  & .entire_app__sidebar_container {
    width: 17%;
    height: 100%;
    background: $mainDimBlue;
    transition: 0.2s ease;
  }

  & .entire_app__page_content {
    width: 83%;
    height: 100%;
    background: $pureWhite;
    transition: 0.2s ease;
    display: flex;
    flex-wrap: wrap;

    .content_container {
      background-color: $pureWhite;
      width: 100%;
      height: 100%;
      font-family: satoshi, $poppins !important;
    }

    .notifications_container {
      background-color: $notificationSide;
      width: 25%;
      height: 100%;
    }
  }
}

@media only screen and (max-width: 600px) {
  #entire_app__dashboard {
    height: auto;

    .ticket_booking_order {
      .ticket_booking_procedure_container {
        .procedure_form {
          width: 92%;
        }
      }
    }

    .entire_app__dashboard {
      .__mobile_navigation {
        display: block;
        width: 100%;
        height: 9vh;
        background: $pureWhite;
        position: fixed;
        top: 0;
        z-index: 5;

        & .logo_container {
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;

          .menu_toggle {
            width: 22%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }

          .--full_width {
            width: 100% !important;
            height: 50% !important;
          }

          .--sidebar_toggled_hide_logo {
            display: none !important;
          }

          .logo {
            width: 56%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 60%;
              margin-top: 0.2em;
            }
          }

          .settings {
            width: 22%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
        }
      }

      .branch-overview {
        display: none;
      }
      .title_container {
        display: none;
      }
      .entire_app__sidebar_container {
        display: none;
      }

      .entire_app__page_content {
        display: block;
        width: 100%;

        .content_container {
          margin-top: 9vh;
          width: 100%;
        }

        .notifications_container {
          display: none;
        }
      }

      .entire_app_mobile_sidebar_container {
        display: block;
        transition: all 0.5s ease;
        z-index: 4;
        width: 100%;
        height: 92vh;
        background: $pureWhite;
        position: fixed;
        top: 8vh;
        animation: slide_up 0.2s linear;
      }

      @keyframes slide_up {
        0% {
          top: 8vh;
        }
        50% {
          top: 5vh;
        }
        100% {
          top: 8vh;
        }
      }
    }
  }
}
</style>
